<template>
  <button :class="{'active': active}" @click="toggleDrawer()">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'DrawerPanelToggler',
  props: {
    target: {
      type: String,
      default: '',
      required: true
    }
  },
  data: () => {
    return {
      active: false
    }
  },
  methods: {
    toggleBtnActive: function() {
      this.active = !this.active
    },
    toggleDrawer: function() {
      const eventDetails = {
        'id': this.target
      }
      const eventDrawerPanelToggle = new CustomEvent('drawerPanelToggle', {'detail': eventDetails})
      document.dispatchEvent(eventDrawerPanelToggle)

      this.toggleBtnActive()
    }
  },
  created: function() {
    document.addEventListener('drawerPanelClosed', (e) => {
      if(this.target == e.detail.id) {

        this.active = false
      }
    })
  }
}
</script>

<style lang="scss" scoped>

  .btn-drawer-toggler {
    padding: 5px 15px;
    background-color: #DFDFDF;
    border: none;
    border-radius: 4px;

    &:focus {
      outline: none;
    }

    &.active {
      background-color: #DFDFDF;
    }
  }
</style>